module.exports = __webpack_public_path__ + "static/media/play-background-4.4a1c0fe1.mp3";